import axios from 'axios';

const createNewKonsultasjon = async (API_BASE_URL, userId, context = "", chosenTemplate, gptModel) => {
  try {
    const newKonsultasjon = {
      kontekst: context,
      start_time: new Date().toISOString(),
      transcript: "",
      notat: "",
      title: "",
      chosen_mal: chosenTemplate,
      chosen_gpt_model: gptModel,
      status: "ongoing",
      user_id: userId
    };
    
    const res = await axios.post(`${API_BASE_URL}/konsultasjoner`, newKonsultasjon, {
      headers: {
        'X-User-Id': userId
      }
    });
    
    return res.data;
  } catch (error) {
    console.error("Error creating consultation:", error);
    throw error;
  }
};

const updateKonsultasjon = async (API_BASE_URL, userId, updated) => {
  try {
    await axios.put(`${API_BASE_URL}/konsultasjoner/${updated.id}`, updated, {
      headers: {
        'X-User-Id': userId
      }
    });
    return updated;
  } catch (error) {
    console.error("Error updating consultation:", error);
    throw error;
  }
};

const deleteKonsultasjon = async (API_BASE_URL, userId, konsultasjonId) => {
  try {
    await axios.delete(`${API_BASE_URL}/konsultasjoner/${konsultasjonId}`, {
      headers: {
        'X-User-Id': userId
      }
    });
    return true;
  } catch (error) {
    console.error("Error deleting consultation:", error);
    throw error;
  }
};

const deleteAllKonsultasjoner = async (API_BASE_URL, userId) => {
  try {
    await axios.delete(`${API_BASE_URL}/konsultasjoner`, {
      headers: {
        'X-User-Id': userId
      }
    });
    return true;
  } catch (error) {
    console.error("Error deleting all consultations:", error);
    throw error;
  }
};

const fetchKonsultasjoner = async (API_BASE_URL, userId) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/konsultasjoner`, {
      headers: {
        'X-User-Id': userId
      }
    });
    return res.data;
  } catch (error) {
    console.error("Error fetching consultations:", error);
    throw error;
  }
};

const fetchTranscript = async (API_BASE_URL, userId, konsultasjonId) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/konsultasjoner/${konsultasjonId}/transcript`, {
      headers: {
        'X-User-Id': userId
      }
    });
    return res.data.transcript;
  } catch (error) {
    console.error("Error fetching transcript:", error);
    throw error;
  }
};

const generateNote = async (API_BASE_URL, userId, transcription, gptModel, templateText, context, konsultasjonId) => {
  try {
    const requestData = {
      transcript: transcription,
      chosen_gpt_model: gptModel,
      template_text: templateText,
      extra_system: context,
      konsultasjon_id: konsultasjonId
    };

    const res = await axios.post(
      `${API_BASE_URL}/generate-note`, 
      requestData,
      {
        headers: {
          'X-User-Id': userId,
          'Content-Type': 'application/json'
        }
      }
    );

    return res.data;
  } catch (error) {
    console.error("Error generating note:", error);
    throw error;
  }
};

export {
  createNewKonsultasjon,
  updateKonsultasjon,
  deleteKonsultasjon,
  deleteAllKonsultasjoner,
  fetchKonsultasjoner,
  fetchTranscript,
  generateNote
};